export default "__VITE_ASSET__BDhmonqk__"